<template>
  <div>
    <label v-if="label" class="font-weight-bold mb-3"> {{ $t('general.input.placeholder.choose-country') }} </label>
    <v-select
      ref="countrySelect"
      custom
      autoscroll
      class="mb-0 px-3 no-close border-gray-300 rounded"
      :options="countries"
      v-model="country"
      :placeholder="$t('general.input.placeholder.select-country')"
      @input="confirmAddCountry()"
    >
      <template #selected-option="{ label, flag }">
        <div class="d-flex align-items-center">
          <img :src="flag" alt="" width="25" />
          <span class="ml-3">{{ label }}</span>
        </div>
      </template>

      <template v-slot:option="option" class="py-4">
        <img :src="option.flag" width="30" height="auto" />
        <span class="ml-2">
          {{ option.label }}
        </span>
      </template>
    </v-select>
  </div>
</template>

<script>
import { nameCountries } from '@/utils/countriesUtils.js'
import vSelect from 'vue-select'
export default {
  name: 'SelectCountry',
  components: {
    vSelect,
  },

  props: {
    selectedCountry: {
      type: String,
    },
    label: {
      type: Boolean,
      default: false,
    },
    hiddenCountrySails: {
      type: Array,
      default: () => [
        'AI',
        'AQ',
        'AW',
        'BY',
        'BM',
        'VA',
        'CW',
        'GS',
        'GI',
        'GL',
        'GP',
        'GU',
        'GG',
        'GF',
        'HK',
        'BV',
        'RE',
        'IM',
        'CX',
        'NF',
        'AX',
        'KY',
        'CC',
        'CK',
        'FO',
        'FK',
        'MP',
        'UM',
        'PN',
        'TC',
        'VI',
        'VG',
        'IT',
        'JE',
        'XK',
        'MO',
        'MQ',
        'YT',
        'MS',
        'NU',
        'NC',
        'HM',
        'BQ',
        'PS',
        'PF',
        'PR',
        'EH',
        'AS',
        'SH',
        'BL',
        'MF',
        'PM',
        'SX',
        'SS',
        'SJ',
        'TW',
        'IO',
        'TF',
        'TK',
        'WF',
      ],
    },
  },

  data() {
    return {
      country: { vies: false, value: 'PT', flag: '/img/flags/pt.svg', label: 'Portugal' },
      isActive: false,
    }
  },
  mounted() {
    this.$emit('add-country', 'PT') //DEFAULT COUNTRY IS PORTUGAL
  },

  computed: {
    countries() {
      return nameCountries(this).filter((item) => !this.hiddenCountrySails.includes(item.value))
    },
  },

  methods: {
    cancelAddCountry() {
      this.country = ''
      this.isActive = false
    },

    confirmAddCountry() {
      this.$emit('add-country', this.country.value)
    },
  },

  watch: {},
}
</script>

<style lang="scss" scope>
.selectCountry {
  &:hover {
    cursor: pointer;
  }
}
</style>
